"use client";
import { useQuery } from "@apollo/client/react";
import { faBadgeCheck, faCircleLocationArrow, faCircleXmark, faComment, faCommentSlash, faUser, faUserSlash } from "@fortawesome/pro-solid-svg-icons";
import dayjs from "dayjs";
import Link from "next/link";

import adminUserBanned from "@/actions/admin-user-banned";
import adminUserPostBan from "@/actions/admin-user-post-ban";
import { DropdownMenu } from "@/components";
import { Statistic } from "@/components/statistic/statistic";
import { ADMIN_USER } from "@/gql/queries/admin-user";

type StudioAdminItemsProps = {
  username: string;
}

export default function StudioAdminItems({ username }: StudioAdminItemsProps) {
  const { data, loading, refetch } = useQuery(ADMIN_USER, { variables: { name: username } });

  if (loading || !data?.adminUser?.id) return null;

  const isPostBanned = data.adminUser.postBannedUntil !== null && dayjs().isBefore(dayjs(data.adminUser.postBannedUntil));
  const timeRemaining = data.adminUser.postBannedUntil !== null ? dayjs(data.adminUser.postBannedUntil).fromNow(true) : null;

  return (<><Statistic title="IP address" icon={faCircleLocationArrow}>
    <Link href={`https://tools.keycdn.com/geo?host=${data?.adminUser?.ip}`}>{data?.adminUser?.ip}</Link>
  </Statistic>
    <Statistic title="Verified" icon={faBadgeCheck}>
      {data?.adminUser?.verified ? 'Yes' : 'No'}
    </Statistic>
    <Statistic title="Banned" icon={faCircleXmark}>
      <DropdownMenu
        button={{ text: data?.adminUser?.banned ? 'Yes' : 'No', type: 'transparent' }}
        items={[
          {
            text: "Active",
            icon: faUser,
            onClick: async () => { await adminUserBanned({ id: data?.adminUser?.id ?? "", isBanned: false }); refetch() }
          },
          {
            text: "Banned",
            icon: faUserSlash,
            onClick: async () => { await adminUserBanned({ id: data?.adminUser?.id ?? "", isBanned: true }); refetch() }
          }
        ]}
      />
    </Statistic>
    <Statistic title="Post banned" icon={faCommentSlash}>
      <DropdownMenu
        button={{ text: isPostBanned ? `${timeRemaining}` : 'No', type: 'transparent' }}
        items={[
          {
            text: "Clear",
            icon: faComment,
            onClick: async () => { await adminUserPostBan({ id: data?.adminUser?.id ?? "", daysToBan: null }); refetch() }
          },
          {
            text: "Ban 1 day",
            icon: faCommentSlash,
            onClick: async () => { await adminUserPostBan({ id: data?.adminUser?.id ?? "", daysToBan: 1 }); refetch() }
          },
          {
            text: "Ban 1 week",
            icon: faCommentSlash,
            onClick: async () => { await adminUserPostBan({ id: data?.adminUser?.id ?? "", daysToBan: 7 }); refetch() }
          }
        ]}
      />
    </Statistic>
  </>)
}